// Gas and transaction constants
export const SAFE_TX_GAS_DEFAULT = '500000'
export const SAFE_TX_GAS_MINIMUM = 100000n
export const SAFE_TX_GAS_BIGINT_MINIMUM = 100000n

// Polling intervals (in milliseconds)
export const POLLING_INTERVAL_PENDING_TRANSACTIONS = 10000
export const POLLING_INTERVAL_BALANCE = 5000
export const TRANSACTION_HISTORY_RELOAD_DELAY = 2000
export const POLLING_INTERVAL_PAUSED_STATUS = 5000
export const POLLING_INTERVAL_STATISTICS = 30000
export const POLLING_INTERVAL_OPERATIONAL_WALLETS = 10000

export const SIMULATION_API_URL = 'https://simulation.safe.global'

// UI dimensions
export const ADDRESS_FORMAT_START_LENGTH = 6
export const ADDRESS_FORMAT_END_LENGTH = 4
export const HASH_DISPLAY_LENGTH = 10
export const CIRCULAR_PROGRESS_SIZE_SMALL = 60
export const SKELETON_WIDTH_SMALL = 100
export const SKELETON_WIDTH_MEDIUM = 140

// Default token decimals
export const DEFAULT_TOKEN_DECIMALS = 6

// Maximum fraction digits for token display
export const MAX_FRACTION_DIGITS = 6

// Signature parsing constants
export const SIGNATURE_LENGTH_FULL = 132 // 0x + 130 hex chars = 65 bytes
export const SIGNATURE_LENGTH_WITH_ADDRESS = 170 // 40 (address) + 130 (signature)
export const ADDRESS_HEX_LENGTH = 40
export const SIGNATURE_HEX_LENGTH = 130
export const HEX_PREFIX_LENGTH = 2 // Length of '0x' prefix

// MetaMask error codes
export const METAMASK_ERROR_CODE_USER_REJECTED = 4001

// UI opacity values
export const OPACITY_DEFAULT = 1
export const OPACITY_DISABLED = 0.7
export const OPACITY_SECONDARY = 0.8
export const OPACITY_HOVER = 0.9
export const OPACITY_LOW = 0.7

// Font weights
export const FONT_WEIGHT_NORMAL = 400
export const FONT_WEIGHT_MEDIUM = 500
export const FONT_WEIGHT_SEMIBOLD = 600
export const FONT_WEIGHT_BOLD = 700

// Spacing values (MUI theme spacing units)
export const SPACING_XS = 0.5
export const SPACING_SM = 1
export const SPACING_MD = 2
export const SPACING_LG = 3
export const SPACING_XL = 4

// Animation durations (in milliseconds)
export const ANIMATION_DURATION_FAST = 300
export const ANIMATION_DURATION_NORMAL = 1000
export const ANIMATION_DELAY_SHORT = 0.3
export const ANIMATION_DELAY_MEDIUM = 0.6

// Notification duration
export const NOTIFICATION_AUTO_HIDE_DURATION = 5000

// Zero address
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

// Safe operation types
export const SAFE_OPERATION_CALL = 0

// Safe transaction value defaults
export const SAFE_TRANSACTION_VALUE_DEFAULT = '0'
export const SAFE_TRANSACTION_DATA_DEFAULT = '0x'
export const SAFE_TRANSACTION_VALUE_HEX_ZERO = '0x0'
export const SAFE_TRANSACTION_DATA_HEX_ZERO = '0x0'

// Safe API constants
export const SAFE_API_DEFAULT_LIMIT = 25
export const SAFES_PER_PAGE = 5
export const TRANSACTIONS_PER_PAGE = 5
export const TRANSACTIONS_RELOAD_DELAY_COUNT = 3

// API rate limiting constants
export const API_REQUEST_DELAY_MS = 500
export const API_RETRY_MAX_ATTEMPTS = 3
export const API_RETRY_DELAY_MS = 2000
export const API_RETRY_BACKOFF_MULTIPLIER = 2
